<div class="modal-content payment-modal">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" (click)="onDismiss()"></button>
    </div>
    <div class="modal-body payment-body">
        <div class="payment-container">
            <!-- Icon and Title Section -->
            <div class="payment-icon-wrapper">
                <div class="payment-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="5" width="20" height="14" rx="2"/>
                        <line x1="2" y1="10" x2="22" y2="10"/>
                    </svg>
                </div>
            </div>

            <h2 class="payment-title">Continúe con el pago</h2>
            <p class="payment-subtitle">Será redirigido a nuestro procesador de pagos seguro</p>

            <!-- Payment Provider Logo -->
            <div class="provider-logo-container">
                <img *ngIf="esPaisChile" 
                     class="provider-logo" 
                     src="/assets/images/logo-venti.svg" 
                     alt="VentiPay">
                <img *ngIf="!esPaisChile" 
                     class="provider-logo" 
                     src="/assets/images/logo-dlocalgo.png" 
                     alt="dLocal Go">
                <div class="provider-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    <span>Pago Seguro</span>
                </div>
            </div>

            <!-- Admin Link Section -->
            <!--div class="admin-link-section" *ngIf="sesion.user.rol_id == 0 || sesion.user.rol_id == 200">
                <div class="admin-link-wrapper">
                    <label class="admin-label">Enlace de pago:</label>
                    <div class="admin-input-group">
                        <input type="text" 
                               class="form-control admin-input" 
                               [ngModel]="url" 
                               readonly>
                        <button class="btn btn-copy" (click)="copy()" title="Copiar enlace">
                            <i class="fas fa-copy"></i>
                        </button>
                    </div>
                </div>
            </div-->

            <!-- Action Button -->
            <button class="btn btn-payment-primary" (click)="abrirEnlacePago()">
                <span class="btn-text">Ir al pago</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
            </button>

            <!-- Information Section -->
            <div class="info-section">
                <div class="info-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                    </svg>
                    <p>El pago podría tardar unos minutos en ser procesado.</p>
                </div>
                <div class="info-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                        <polyline points="22 4 12 14.01 9 11.01"/>
                    </svg>
                    <p>Una vez finalizado el pago, si su información no se actualiza automáticamente, puede cerrar esta ventana y recargar la página.</p>
                </div>
            </div>
        </div>
    </div>
</div>